import { Link } from "react-router-dom";
import { IconBack, IconLayout } from "../control/ui/icons";

/**
 * "‹ Views" for the SiteBar's `back` slot — worn by a screen a Quick setup on Views
 * opened (see lib/screenOrigin). One component because two pages wear it: the pending
 * screen a guest lands on, and the device a signed-in tab becomes a moment later.
 *
 * A CHIP, in the bar's own grammar: the same pill, hairline and fill as the code chip on
 * the far side, with the Views glyph the ☰ uses for that page. It first shipped as bare
 * grey text beside the wordmark, which read as a stray label rather than a control
 * (owner, 2026-10-10). Below `sm:` it is the chevron alone, a round button like the screen's own — a phone bar
 * has no room for a second glyph. Under 375px there is no room for it at all (the bar's
 * own controls already fill a 360px row and it pushed the ☰ off the edge), so it steps
 * aside there and the browser's Back does the job.
 */
export function BackToViews() {
  return (
    <Link
      to="/views"
      aria-label="Back to views"
      title="Back to views"
      className="ml-1.5 inline-flex shrink-0 max-[374px]:hidden items-center gap-1.5 rounded-full border border-white/15 bg-white/5 p-2 text-sm text-zinc-300 transition-colors hover:bg-white/15 hover:text-white sm:ml-4 sm:py-1.5 sm:pl-1.5 sm:pr-3"
    >
      <IconBack width={14} height={14} className="sm:text-zinc-500" />
      <IconLayout width={15} height={15} className="hidden sm:block" />
      <span className="hidden sm:inline">Views</span>
    </Link>
  );
}
